import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ListItem from 'components/Luxkit/List/ListItem'
import ListItemLoadingSkeleton from 'components/Luxkit/List/ListItemLoadingSkeleton'
import { rem } from 'polished'
import React, { useCallback, useContext, useEffect } from 'react'
import Heading from 'components/Luxkit/Typography/Heading'
import LineShipIcon from 'components/Luxkit/Icons/line/LineShipIcon'
import CruiseLineListItem from './CruiseLineListItem'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'
import styled from 'styled-components'
import { fetchCruiseLines } from 'actions/CruiseActions'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { without } from 'lib/arrayUtils'

const CruiseLineListWrapper = styled.div`
  display: flex;
  gap: ${rem(19)};
  padding: ${rem(8)};
  align-items: center;
  flex-wrap: wrap;
  overflow-y: auto;
  justify-content: center;

  ${mediaQueryUp.sm} {
    justify-content: flex-start;
    max-height: ${rem(340)};
  }
`

const HeadingText = styled(Heading)`
  display: none;
  padding: 0 ${rem(8)};

  ${mediaQueryUp.sm} {
    display: block;
  }
`

interface Props {
  className?: string;
  onSelect: (cruiseLines: string[] | []) => void;
  cruiseLines: Array<App.CruiseLine>;
  fetchingCruiseLines: boolean;
}

function CruiseLinesSerchList(props: Props) {
  const { className, cruiseLines, fetchingCruiseLines, onSelect } = props
  const dispatch = useAppDispatch()

  const { cruiseLines: searchCruiseLines } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  useEffect(() => {
    dispatch(fetchCruiseLines())
  }, [dispatch])

  const handleSelectVendor = useCallback((cruiseLine: string) => {
    let nextCruiseLines: string[] = []

    const alreadyExists = searchCruiseLines.includes(cruiseLine)
    if (alreadyExists) {
      nextCruiseLines = without(searchCruiseLines, cruiseLine)
    } else {
      nextCruiseLines = [...searchCruiseLines, cruiseLine]
    }

    searchDispatch({ type: GlobalSearchStateActions.SET_CRUISE_LINES, cruiseLines: nextCruiseLines })
    onSelect(nextCruiseLines)
  }, [searchCruiseLines, searchDispatch, onSelect])

  const onSelectAllVendors = useCallback(() => {
    searchDispatch({ type: GlobalSearchStateActions.SET_CRUISE_LINES, cruiseLines: [] })
    onSelect && onSelect([])
  }, [searchDispatch, onSelect])

  return <LayoutContainer>
    <VerticalSpacer gap={8} className={className}>
      <ListItem
        title="All cruise lines"
        startIcon={<LineShipIcon />}
        onClick={onSelectAllVendors}
      />
      <HeadingText variant="heading6">Trending cruise lines</HeadingText>
      {fetchingCruiseLines && <>
        <ListItemLoadingSkeleton subtitle />
        <ListItemLoadingSkeleton subtitle />
        <ListItemLoadingSkeleton subtitle />
      </>}
      {!fetchingCruiseLines && <CruiseLineListWrapper>
        {cruiseLines.map(cruiseLine => <CruiseLineListItem
          key={cruiseLine.imageId}
          cruiseLine={cruiseLine}
          isSelected={searchCruiseLines?.includes(cruiseLine.code)}
          onClick={handleSelectVendor}
        />)}
      </CruiseLineListWrapper>}
    </VerticalSpacer>
  </LayoutContainer>
}

function mapStateToProps(state: App.State) {
  return {
    cruiseLines: state.cruise.cruiseLines,
    fetchingCruiseLines: state.cruise.fetchingCruiseLines,
  }
}

export default connect(mapStateToProps)(CruiseLinesSerchList)
